<!-- Presentational component for displaying a single clickable menu item -->
<template>
	<li>
		<button
			@click="$emit('click')"
			type="button"
			class="group/menuitem bg-background-50 hover:bg-background-25 flex w-full items-start px-4 py-3"
		>
			<div
				class="group-hover/menuitem:text-accent-500 grow text-left text-sm font-bold uppercase"
				:class="[active ? 'text-accent-500' : 'text-secondary-900']"
			>
				<slot></slot>
			</div>
			<slot name="icon">
				<CaretArrowIcon
					class="group-hover/menuitem:fill-accent-500 fill-slate-500"
				/>
			</slot>
		</button>
	</li>
</template>

<script setup lang="ts">
import CaretArrowIcon from '../icons/CaretArrowIcon.vue'

defineEmits(['click'])

defineProps({
	active: Boolean,
})
</script>
